import { render, staticRenderFns } from "./RuleEditor.vue?vue&type=template&id=6a78f844&"
import script from "./RuleEditor.vue?vue&type=script&lang=js&"
export * from "./RuleEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports